import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Authorization from '../Authorization';
import MenuItem from './MenuItem';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE } from '../../constants';
import { IsAdmin } from '../../utils/Roles';
import GetTheaterId from '../../utils/GetTheaterId';

class Banner extends Component {
  handleLogout = () => {
    localStorage.removeItem('escenaToken');
    localStorage.removeItem('escenaRole');
    localStorage.removeItem('escenaTheater');
    localStorage.removeItem('escenaStats');
    localStorage.removeItem('escenaPlan');
  };

  render() {
    return (
      <header className="main-header">
        <div className="container">
          <nav className="navbar navbar-default">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#app-navigation"
                aria-expanded="false"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <Link to="/" className="logo">
                <img src="/img/logos/logo-2.png" alt="logo" />
              </Link>
            </div>

            <div
              className="navbar-collapse collapse"
              role="navigation"
              aria-expanded="true"
              id="app-navigation"
            >
              <ul className="nav navbar-nav">
                <MenuItem
                  title="Producciones"
                  to="/productions"
                  adminTitle="Administrar producciones"
                  adminTo="/admin/productions"
                />
                <MenuItem
                  title="Teatros"
                  to="/theaters"
                  adminTitle="Administrar teatros"
                  adminTo={IsAdmin() ? '/admin/theaters' : `/admin/theater/${GetTheaterId()}`}
                />
                <MenuItem
                  title="Artistas"
                  to="/artists"
                  adminTitle="Administrar artistas"
                  adminTo="/admin/artists"
                />
              </ul>
              <ul className="nav navbar-nav navbar-right rightside-navbar">
                <MenuItem
                  title="FAQ"
                  to="/faq"
                />
                <MenuItem
                  title="Toolkit"
                  to="/toolkit"
                />
                <MenuItem
                  title="Membresías"
                  to="/plans"
                />
                <MenuItem
                  title="Acerca de"
                  to="/about"
                />
                <li className="navbar-right-button">
                  <Authorization allowed={['guest']}>
                    <Link to="/login" className="button">
                      Ingresar
                    </Link>
                  </Authorization>
                  <Authorization allowed={['artist']}>
                    <Link to="/me/edit" className="button">
                      Perfil
                    </Link>
                  </Authorization>
                  <Authorization allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
                    <Link to="/admin/productions" className="button">
                      Administrar
                    </Link>
                  </Authorization>
                  <Authorization allowed={['user']}>
                    <Link to="/login" onClick={this.handleLogout} className="button">
                      Cerrar sesión
                    </Link>
                  </Authorization>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/index.js